// C:\Users\USER\bookfete\frontend\src\components\dashboard\DashboardIcons.js
import React from 'react';

export const IconBook = ({ className, style }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} style={style}>
    <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconCheckCircle = ({ className, style }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} style={style}>
    <circle cx="12" cy="12" r="10"/>
    <path d="M8 12L11 15L16 9" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconArchive = ({ className, style }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} style={style}>
    <path d="M4 4H20V8H4V4Z" strokeLinejoin="round"/>
    <path d="M8 12H16" strokeLinecap="round"/>
    <path d="M6 8V18C6 18.5304 6.21071 19.0391 6.58579 19.4142C6.96086 19.7893 7.46957 20 8 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconPhoto = ({ className, style }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} style={style}>
    <path d="M4 5H20V19H4V5Z" strokeLinejoin="round"/>
    <circle cx="9" cy="10" r="1.5"/>
    <path d="M4 16L9 12L13 15L17 11L20 14" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconContribution = ({ className, style }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} style={style}>
    <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" strokeLinejoin="round"/>
    <path d="M8 9H16" strokeLinecap="round"/>
    <path d="M8 13H13" strokeLinecap="round"/>
  </svg>
);

export const IconPlus = ({ className, style }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} style={style}>
    <path d="M10 4V16" strokeLinecap="round"/>
    <path d="M4 10H16" strokeLinecap="round"/>
  </svg>
);

export const IconRestore = ({ className, style }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} style={style}>
    <path d="M4 10C4 7.87827 4.84285 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10C20 12.1217 19.1571 14.1566 17.6569 15.6569C16.1566 17.1571 14.1217 18 12 18H8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 14L4 18L8 22" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const IconMore = ({ className, style }) => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor" className={className} style={style}>
    <circle cx="4" cy="10" r="1.6"/>
    <circle cx="10" cy="10" r="1.6"/>
    <circle cx="16" cy="10" r="1.6"/>
  </svg>
);

export const IconDelete = ({ className, style }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} style={style}>
    <path d="M2.5 5H17.5" strokeLinecap="round"/>
    <path d="M6.5 5V3.5C6.5 3.10218 6.65804 2.72064 6.93934 2.43934C7.22064 2.15804 7.60218 2 8 2H12C12.3978 2 12.7794 2.15804 13.0607 2.43934C13.342 2.72064 13.5 3.10218 13.5 3.5V5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.5 5V16.5C15.5 16.8978 15.342 17.2794 15.0607 17.5607C14.7794 17.842 14.3978 18 14 18H6C5.60218 18 5.22064 17.842 4.93934 17.5607C4.65804 17.2794 4.5 16.8978 4.5 16.5V5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);